import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppointmentState } from "../../types";

interface AddAppointmentPayload {
  stage: number;
  domain?: string;
  shopData?: any;
  rwg_token?: string;
  entryStage?: number;
  specId?: number;
  [key: string]: any;
}

interface UpdateAppointmentPayload {
  updates: Partial<AppointmentState>;
}

interface ResetAppointmentPayload {
  dispatchData: Partial<AppointmentState>;
}

const initialState: AppointmentState = {
  stage: 0,
};

const appointmentSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    addAppointment(state, action: PayloadAction<AddAppointmentPayload>) {
      state.stage = action.payload.stage;
      state.domain = action.payload.domain;
      state.shopData = action.payload.shopData;
      state.rwg_token = action.payload.rwg_token;
      state.entryStage = action.payload.entryStage;
      state.specId = action.payload.specId;
    },
    updateAppointment(state, action: PayloadAction<UpdateAppointmentPayload>) {
      return {
        ...state,
        vehicle: action.payload.updates.vehicle
          ? { ...state.vehicle, ...action.payload.updates.vehicle }
          : state.vehicle,
        ...action.payload.updates,
      };
    },
    resetAppointment(state, action: PayloadAction<ResetAppointmentPayload>) {
      return {
        ...action.payload.dispatchData,
      };
    },
  },
});

export const { addAppointment, updateAppointment, resetAppointment } =
  appointmentSlice.actions;
export default appointmentSlice.reducer;
